import { API } from 'src/api';
import { formatBoardData } from 'src/features/boards';

export function formatName(name) {
  return [
    {
      type: 'p',
      children: [
        {
          text: name,
        },
      ],
    },
  ];
}

export async function getBacklogsAndSprints(id: string, filters?: any) {
  const apiData = {
    id: id,
  };
  if (filters) {
    apiData['filters'] = filters;
  }
  try {
    const response = await API.post(`agile/backlog`, apiData);
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function addItemToSprint(id: string, name: any, description: any) {
  try {
    const response = await API.post(`agile/sprint/add/item`, {
      sprint: id,
      type: 'story',
      name: [
        {
          type: 'p',
          children: [
            {
              text: name,
            },
          ],
        },
      ],
      description: [
        {
          type: 'p',
          children: [
            {
              text: description,
            },
          ],
        },
      ],
    });
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function startSprint(id: string, sprintStartDate, sprintEndDate) {
  try {
    const response = await API.post(`agile/sprint/action`, {
      sprint: id,
      run: 1,
      sprintStartDate,
      sprintEndDate,
    });
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}
export async function completeSprint(id: string) {
  try {
    const response = await API.post(`agile/sprint/action`, {
      sprint: id,
      run: 0,
    });
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function createSprint(title: string, description: string, fileId: string) {
  try {
    const response = await API.post(`agile/sprint`, {
      title,
      description,
      fileRef: fileId,
    });
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function createBacklogItem(name: string, fileId: string) {
  try {
    const response = await API.post(`agile/backlog`, {
      name: [
        {
          type: 'p',
          children: [
            {
              text: name,
            },
          ],
        },
      ],
      fileRef: fileId,
      type: 'story',
    });
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function editSprint(payload: any) {
  try {
    const response = await API.put(`agile/sprint`, payload);
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function createEpic(name: string, description: string, fileId: string) {
  try {
    const response = await API.post(`agile/epic`, {
      type: 'epic',
      fileRef: fileId,
      name: formatName(name),
      description: formatName(description),
    });
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function deleteEpic(epicId: string) {
  try {
    const response = await API.delete(`agile/epic?id=${epicId}`);
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function fetchEpics(fileId: string, filters?: any) {
  try {
    const apiData = {
      filters,
      id: fileId,
    };
    const response = await API.post(`agile/epic?fileRef=${fileId}`, apiData);
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function fetchActiveSprints(fileId: string) {
  try {
    const response = await API.get(`agile/sprint?fileRef=${fileId}&q=active`);
    if (response.data.success) {
      return {
        activeSprints: response.data.data.sprints,
        boardData: formatBoardData(response.data.data.board),
      };
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function fetchSprints(fileId: string) {
  try {
    const response = await API.get(`agile/sprint?fileRef=${fileId}&q=all`);
    if (response.data.success) {
      return formatBoardData(response.data.data);
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function getSprintBoard(fileId: string, selected: string[], filters?: any) {
  try {
    const apiData = {
      fileRef: fileId,
      selected: selected,
    };
    if (filters) {
      apiData['filters'] = filters;
    }
    const response = await API.post(`agile/sprint/get`, apiData);
    if (response.data.success) {
      return {
        activeSprints: response.data.data.sprints,
        boardData: formatBoardData(response.data.data.board),
      };
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function fetchSprintById(sprintId: string) {
  try {
    const response = await API.get(`agile/sprint?id=${sprintId}`);
    if (response.data.success) {
      return formatBoardData(response.data.data);
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}
export async function deleteSprintById(sprintId: string) {
  try {
    const response = await API.delete(`agile/sprint?id=${sprintId}`);
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function assignEpic(taskId: string, epicId: string) {
  try {
    const response = await API.post(`agile/epic/assign`, {
      task: taskId,
      epic: epicId,
    });
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}
export async function assignTaskToSprint(task: string[], sprintId: string) {
  try {
    const response = await API.post(`agile/item/assign`, {
      task,
      sprint: sprintId,
    });
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function assignTaskToBacklog(task: any) {
  try {
    const response = await API.post(`agile/item/move/backlog`, {
      item: task,
    });
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function getAnalyticsForSprint(sprintId: string) {
  try {
    const response = await API.get(`agile/analytics?sprint=${sprintId}`);
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}

export async function getFileAnalytics(fileId: string) {
  try {
    const response = await API.get(`agile/analytics?id=${fileId}`);
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}
export async function getSprintAnalytics(sprintId: string) {
  try {
    const response = await API.get(`agile/analytics?sprint=${sprintId}`);
    if (response.data.success) {
      return response.data.data;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}
